<span class="title">REPLACE SHOW</span>
<div class="main-form" *ngIf="viewModelState === 0">
  <div class="media-input-container">
    <div class="new-media-id">NAME OF NEW MEDIA ID</div>
    <input type="text" [(ngModel)]="mediaCustomId" />
  </div>

  <div class="media-input-container">
    <div class="checkbox-input" [class.active]="applyToAllInstances">
      <div (click)="applyToAllInstances = !applyToAllInstances">
        <svg viewBox="0 0 21.02 14.02">
          <path
            fill-rule="evenodd"
            d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
          />
        </svg>
      </div>
    </div>
    <span class="label-apply-all">Apply to all instances in the calendar</span>
  </div>
  <div
    class="until-container"
    [style.visibility]="applyToAllInstances ? 'visible' : 'hidden'"
  >
    <span class="until-text">Until:</span>
    <dateinput [(current)]="untilDate" [noTimePicker]="false"></dateinput>
  </div>
</div>
<evrideo-replace-show-item-is-longer
  *ngIf="viewModelState === 2"
  (strategyChanged)="replaceShowStrategy = $event"
  [channelFramerate]="channelFramerate"
  [differenceInMS]="deltaBetweenShowAndMediaInMs"
></evrideo-replace-show-item-is-longer>
<evrideo-replace-show-item-is-shorter
  *ngIf="viewModelState === 3"
  (strategyChanged)="replaceShowStrategy = $event"
  [channelFramerate]="channelFramerate"
  [differenceInMS]="deltaBetweenShowAndMediaInMs"
></evrideo-replace-show-item-is-shorter>
<div class="apply-cancel-container">
  <a class="btn btn-cancel" (click)="cancel()">Cancel</a>
  <a class="btn btn-replace" (click)="replace()">Replace</a>
</div>
